import { get } from "lodash";
import { LoanTypeEnum } from "../enum/loan-type.enum";
import { PropertyFinancingInfo } from "../polymer/Properties.model";

export class ApplicationStep2 extends PropertyFinancingInfo{
  //NOTE: Current mean "OLD" loan, new mean "use selected in the step 2 application";
  new_loan_type : LoanTypeEnum | undefined;
  
  constructor(initial?:any){
    super(initial);
    this.new_loan_type = get(initial, 'new_loan_type', undefined);
  }
}
